$(document).ready(function(){
    // Slider
    $('.quoi_falc-exemples-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
        if (!e.namespace)  {
          return;
        }
        var carousel = e.relatedTarget;
        $('.slider-counter').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
      }).owlCarousel({
        loop:false,
        items : 1,
        nav:true,
        dots : false,
        navContainer: '.nav-slider',
        navElement: 'button type="button" role="presentation"',
        navText : ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
    });
    $('.traduction_couts-exemples-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
        if (!e.namespace)  {
          return;
        }
        var carousel = e.relatedTarget;
        $('.slider-counter-traduction').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
      }).owlCarousel({
        loop:false,
        items : 1,
        nav:true,
        margin : 40,
        dots : false,
        navContainer: '.nav-slider-traduction',
        navElement: 'button type="button" role="presentation"',
        navText : ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
    });
    $('.slider-clients').owlCarousel({
        dots : false,
        nav:true,
        navContainer: '.nav-slider-clients',
        navElement: 'button type="button" role="presentation"',
        navText : ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
        responsive:{
          0:{
              items:1,
          },
          500:{
              items:2,
          },
          700:{
              items:3,
          },
          1000:{
              items:4,
          },
          1200:{
              items:6,
          }
      }
    });

    $('button.owl-prev').attr('aria-label','Slide précédent');
    $('button.owl-next').attr('aria-label','Slide suivant');
});